import React, {createContext, useReducer} from 'react'
import {ReceiveOverViewReducer} from  "../reducers/ReceiveOverViewReducer";

export const ReceiveOverViewContext = createContext();

const ReceiveOverViewContextProvider = (props) => {
    const reviewOverview = {
        total_predicated_plan: '',
        planned_cycle_volume: '',
        actual_cycle_volume: '',
        actual_total_volume: '',
        other_cycle_volume: '',
        actual_pending_depart_from_upstream: '',
        actual_pending_depart_from_upstream_unplanned: '',
        actual_in_transit_from_upstream: '',
        actual_in_transit_from_upstream_unplanned: '',
        actual_pending_induct: '',
        actual_pending_induct_unplanned: '',
        actual_pending_re_induct: '',
        actual_pending_re_induct_unplanned: '',
        actual_inducted: '',
        actual_stowed: '',
        actual_sidelined: '',
        problem_solve: ''
    }
    const [viewModel, dispatch ] = useReducer(ReceiveOverViewReducer, reviewOverview)
    return (
        <ReceiveOverViewContext.Provider value = {{viewModel, dispatch}}>
            {props.children}
        </ReceiveOverViewContext.Provider>
    )
}

export default ReceiveOverViewContextProvider


// WEBPACK FOOTER //
// ./src/components/receive/context/ReceiveOverViewContext.js